module.exports = __webpack_public_path__ + "img/appshelves.9cabd374.png";